export function initQuickLinks() {
  const sections = document.querySelectorAll(".js-quick-links");
  if (!sections.length) return;

  sections.forEach((sectionEl) => {
    const sliderEl = sectionEl.querySelector(".quick-links__slider");
    if (!sliderEl) return;

    let swiperInstance = null;
    const mobileQuery = window.matchMedia("(max-width: 767px)");
    const btnPrev = sectionEl.querySelector(".quick-links__nav-btn--prev");
    const btnNext = sectionEl.querySelector(".quick-links__nav-btn--next");

    const initSwiper = () => {
      if (swiperInstance) return;

      swiperInstance = new Swiper(sliderEl, {
        slidesPerView: 2.2,
        spaceBetween: 12,
        watchOverflow: true,
        pagination: false,
        navigation:
          btnPrev && btnNext
            ? {
                prevEl: btnPrev,
                nextEl: btnNext,
              }
            : undefined,
      });
    };

    const destroySwiper = () => {
      if (!swiperInstance) return;
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    };

    const handleViewportChange = () => {
      if (mobileQuery.matches) {
        initSwiper();
      } else {
        destroySwiper();
      }
    };

    handleViewportChange();

    if (typeof mobileQuery.addEventListener === "function") {
      mobileQuery.addEventListener("change", handleViewportChange);
    } else {
      mobileQuery.addListener(handleViewportChange);
    }
  });
}
